var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.theme }, [
    _c("div", { staticClass: "title" }, [
      _c("img", { attrs: { src: _vm.titleImg } }),
      _vm.language === "zh"
        ? _c("div", { staticClass: "text" }, [
            _c("div", { ref: "myDiv", staticStyle: { "z-index": "999" } }, [
              _vm._v(_vm._s(_vm.zhTitle)),
            ]),
            _c("div", {
              class: _vm.isLongChart ? "" : "bg",
              style: { width: _vm.bgWidth + "px" },
            }),
          ])
        : _vm.language === "en"
        ? _c("div", { staticClass: "text" }, [
            _c("div", { ref: "myDiv", staticStyle: { "z-index": "999" } }, [
              _vm._v(_vm._s(_vm.enTitle)),
            ]),
            _c("div", {
              class: _vm.isLongChart ? "" : "bg",
              style: { width: _vm.bgWidth + "px" },
            }),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }